var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"jc-page-header"},[_c('h1',[_vm._v("\n      "+_vm._s(_vm.title)+"\n      "),_vm._t("card-head")],2),_c('div',{staticClass:"jc-box-action"},[_vm._t("card-message",function(){return [_c('a',{attrs:{"href":_vm.linkAddress,"target":"_blank"}},[_vm._v(_vm._s(_vm.linkMessage))])]}),_vm._t("card-tail")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }